import React, { forwardRef } from 'react';
import InputTemplate from '../TemplateNumberFormatInput';

const PrecoInput = forwardRef(({ escala = 2, ...props }, ref) => (
  <InputTemplate {...props} escala={escala} prefixo="R$: " ref={ref} />
));

export default PrecoInput;
